"use strict";

export { default as TouchableHighlight } from './TouchableHighlight';
export { default as TouchableNativeFeedback } from './TouchableNativeFeedback';
export { default as TouchableOpacity } from './TouchableOpacity';
export { default as TouchableWithoutFeedback } from './TouchableWithoutFeedback';
//# sourceMappingURL=index.js.map